import { render, staticRenderFns } from "./TopCategoryTile.vue?vue&type=template&id=264a0b17&"
import script from "./TopCategoryTile.vue?vue&type=script&lang=js&"
export * from "./TopCategoryTile.vue?vue&type=script&lang=js&"
import style0 from "./TopCategoryTile.vue?vue&type=style&index=0&id=264a0b17&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,SvgIconRightArrow: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconRightArrow.vue').default,CmsLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsLink.vue').default})
